// extracted by mini-css-extract-plugin
export default {"root":"UnityHubSettingsDescription_root__AqXri"};